// TPE Homepage scroll-driven animations: hero ring, float archive, grid reveal
(function () {
  'use strict';

  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }

  // ---------- HERO ----------
  function initHero(hero) {
    var ring = hero.querySelector('[data-tpe-hero-ring]');
    var marker = hero.querySelector('[data-tpe-hero-marker]');
    var cueBar = hero.querySelector('[data-tpe-hero-cue-bar]');
    var cueNum = hero.querySelector('[data-tpe-hero-cue-num]');
    if (!ring) return;
    var posters = Array.prototype.slice.call(ring.querySelectorAll('[data-tpe-hero-poster]'));
    var count = posters.length;
    if (!count) return;

    var raf = 0;
    function tick() {
      raf = 0;
      var vw = window.innerWidth;
      var heroH = hero.offsetHeight || window.innerHeight;
      var scrollY = window.scrollY;
      var vh = window.innerHeight;
      var progress = clamp(scrollY / (vh * 1.5), 0, 1);

      // Tighter radius so posters don't crowd the wordmark on short screens.
      // Center is pushed deeper (0.44 vs 0.32) so the arc sits in the mid-zone.
      var radius = Math.max(vw * 0.44, 420);
      var centerY = radius + heroH * 0.44;
      var rotation = -15 + progress * 60;

      var posterW = clamp(heroH * 0.17, 100, 150);
      if (vw <= 720) posterW = 120;
      var posterH = posterW * (594 / 420);

      if (marker) {
        marker.style.transform = 'scale(' + (1 + progress * 0.1) + ')';
        marker.style.opacity = String(1 - progress * 0.4);
      }

      for (var i = 0; i < count; i++) {
        var t = i / (count - 1);
        var baseAngle = -60 + t * 120;
        var speed = 0.7 + t * 0.8;
        var angle = baseAngle + rotation * speed;
        var rad = angle * Math.PI / 180;
        var x = Math.sin(rad) * radius;
        var y = -Math.cos(rad) * radius;
        var abs = Math.abs(((angle % 360) + 540) % 360 - 180);
        var visible = abs < 75;
        var op = !visible ? 0 : abs > 60 ? (75 - abs) / 15 : 1;

        var el = posters[i];
        el.style.left = '50%';
        el.style.top = centerY + 'px';
        el.style.width = posterW + 'px';
        el.style.height = posterH + 'px';
        el.style.transform = 'translate(-50%, -50%) translate(' + x + 'px, ' + y + 'px) rotate(' + (angle * 0.25) + 'deg)';
        el.style.opacity = String(op);
      }

      if (cueBar) cueBar.style.transform = 'scaleX(' + progress + ')';
      if (cueNum) cueNum.textContent = String(Math.round(progress * 100)).padStart(2, '0') + '%';
    }
    function onScroll() { if (!raf) raf = requestAnimationFrame(tick); }
    tick();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  // ---------- FLOAT ARCHIVE ----------
  function initFloat(section) {
    var stage = section.querySelector('[data-tpe-float-stage]');
    if (!stage) return;
    var thumbs = Array.prototype.slice.call(section.querySelectorAll('[data-tpe-float-thumb]'));
    var raf = 0;
    function tick() {
      raf = 0;
      var rect = section.getBoundingClientRect();
      var vh = window.innerHeight;
      var total = rect.height + vh;
      var scrolled = vh - rect.top;
      var progress = clamp(scrolled / total, 0, 1);

      for (var i = 0; i < thumbs.length; i++) {
        var t = thumbs[i];
        var delay = parseFloat(t.dataset.delay || '0');
        var dx = parseFloat(t.dataset.dx || '0');
        var dy = parseFloat(t.dataset.dy || '0');
        var rot = parseFloat(t.dataset.rot || '0');
        var p = clamp((progress - delay) * 1.6, 0, 1);
        var eased = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
        var tx = (eased - 0.5) * dx * 2;
        var ty = (eased - 0.5) * dy * 2;
        t.style.transform = 'translate3d(' + tx + 'px, ' + ty + 'px, 0) rotate(' + rot + 'deg)';
      }
    }
    function onScroll() { if (!raf) raf = requestAnimationFrame(tick); }
    tick();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  // ---------- STUDIO GRID REVEAL ----------
  function initGrid(section) {
    if (!('IntersectionObserver' in window)) {
      section.setAttribute('data-in', 'true');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          section.setAttribute('data-in', 'true');
          io.disconnect();
        }
      });
    }, { threshold: 0.15 });
    io.observe(section);
  }

  function boot() {
    document.querySelectorAll('[data-tpe-hero]').forEach(initHero);
    document.querySelectorAll('[data-tpe-float]').forEach(initFloat);
    document.querySelectorAll('[data-tpe-grid]').forEach(initGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
